/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened class="el-menu-vertical-demo tb-side-menu" background-color="transparent" text-color="#5d7090" active-text-color="#409eff">
    <div class="logobox">
      <div class="logo-glow">
        <img class="logoimg" src="../assets/img/logo.png" alt="">
      </div>
      <div class="logo-title" v-if="!collapsed">
        <span class="logo-en">YIJIU ADMIN</span>
        <span class="logo-cn">简洁管理后台</span>
      </div>
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid + '-' + menu.menuname" :index="menu.menuname">
      <template slot="title">
        <i :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid + '-' + chmenu.url" @click="handleMenuClick(chmenu)">
          <i :class="chmenu.icon"></i>
          <span class="menu-label">
            <span>{{chmenu.menuname}}</span>
            <el-badge
              v-if="getMenuBadgeCount(chmenu) > 0"
              :value="getMenuBadgeCount(chmenu)"
              :max="99"
              class="pending-skill-badge"
            ></el-badge>
          </span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu, getAdminNotificationSummary } from '../api/userMG'
import { playNotificationSound, unlockNotificationAudio } from '../utils/adminNotificationSound'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: [],
      pendingSkillCount: 0,
      latestPendingSkillId: 0,
      latestPendingSkillUpdateTime: 0,
      feedbackTotal: 0,
      latestFeedbackId: 0,
      newFeedbackCount: 0,
      notificationSummaryReady: false,
      pendingSkillTimer: null,
      soundUnlockHandler: null
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // 获取图形验证码
    let res = {
      success: true,
      data: [
        {
          menuid: 0,
          icon: 'el-icon-menu',
          menuname: '数据看板',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 1,
              icon: 'el-icon-tickets',
              menuname: '运营大屏',
              hasThird: 'N',
              url: 'dashboard/Screen',
              menus: null
            }
          ]
        },
        {
          menuid: 1,
          icon: 'el-icon-user-solid',
          menuname: '用户管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 1,
              icon: 'el-icon-s-custom',
              menuname: '用户列表',
              hasThird: 'N',
              url: 'user/User',
              menus: null
            },
            {
              menuid: 1,
              icon: 'el-icon-connection',
              menuname: '在线用户列表',
              hasThird: 'N',
              url: 'user/onLine',
              menus: null
            },
            {
              menuid: 1,
              icon: 'el-icon-warning-outline',
              menuname: '用户投诉',
              hasThird: 'N',
              url: 'user/Feedback',
              menus: null
            }
          ]
        },

        {
          menuid: 2,
          icon: 'el-icon-s-order',
          menuname: '订单管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 3,
              icon: 'el-icon-document',
              menuname: '交易订单',
              hasThird: 'N',
              url: 'pay/Order',
              menus: null
            }
          ]
        },
        {
          menuid: 4,
          icon: 'el-icon-s-goods',
          menuname: '技能管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 5,
              icon: 'el-icon-goods',
              menuname: '技能审核',
              hasThird: 'N',
              url: 'goods/Goods',
              menus: null
            },
          ]
        },

        {
          menuid: 6,
          icon: 'el-icon-s-finance',
          menuname: '财务管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 7,
              icon: 'el-icon-tickets',
              menuname: '账单明细',
              hasThird: 'N',
              url: 'finance/Finance',
              menus: null
            },
            {
              menuid: 8,
              icon: 'el-icon-bank-card',
              menuname: '提现管理',
              hasThird: 'N',
              url: 'finance/Withdraw',
              menus: null
            },

          ]
        },
        {
          menuid: 10,
          icon: 'el-icon-s-platform',
          menuname: '平台管理',
          hasThird: null,
          url: null,
          menus: [

            {
              menuid: 12,
              icon: 'el-icon-picture-outline',
              menuname: '轮播图管理',
              hasThird: 'N',
              url: 'terrace/Carousel',
              menus: null
            },
            {
              menuid: 14,
              icon: 'el-icon-document-checked',
              menuname: '协议管理',
              hasThird: 'N',
              url: 'terrace/Agreement',
              menus: null
            },
            {
              menuid: 14,
              icon: 'el-icon-menu',
              menuname: '分类管理',
              hasThird: 'N',
              url: 'terrace/NewsClassify',
              menus: null
            },
            {
              menuid: 14,
              icon: 'el-icon-files',
              menuname: '分类管理二级',
              hasThird: 'N',
              url: 'terrace/NewsClassifyTwo',
              menus: null
            }
            ,
            {
              menuid: 14,
              icon: 'el-icon-s-tools',
              menuname: '基础设置',
              hasThird: 'N',
              url: 'terrace/Valuation',
              menus: null
            }


          ]
        },


      ],
      msg: 'success'
    }
    
    var Admin =  {
          menuid: 111,
          icon: 'el-icon-s-cooperation',
          menuname: '系统管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 71,
              icon: 'el-icon-user',
              menuname: '管理员设置',
              hasThird: 'N',
              url: 'system/Admin',
              menus: null
            }
          ]
        }

        var userdata = JSON.parse(localStorage.getItem("userdata"))

      if (userdata.username=="admin") {
        res.data.push(Admin)
      }
console.log("userdata",userdata)
        
    

    this.allmenu = res.data
    
    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
    })
    this.soundUnlockHandler = () => unlockNotificationAudio()
    document.addEventListener('click', this.soundUnlockHandler)
    document.addEventListener('keydown', this.soundUnlockHandler)
    this.refreshAdminNotifications()
    this.pendingSkillTimer = setInterval(() => {
      this.refreshAdminNotifications()
    }, 10000)
  },
  watch: {
    '$route.path'(path) {
      if (String(path || '').toLowerCase() === '/user/feedback') {
        this.newFeedbackCount = 0
      }
    }
  },
  beforeDestroy() {
    if (this.pendingSkillTimer) {
      clearInterval(this.pendingSkillTimer)
      this.pendingSkillTimer = null
    }
    if (this.soundUnlockHandler) {
      document.removeEventListener('click', this.soundUnlockHandler)
      document.removeEventListener('keydown', this.soundUnlockHandler)
      this.soundUnlockHandler = null
    }
  },
  methods: {
    isSkillAuditMenu(menuItem) {
      return menuItem && menuItem.url === 'goods/Goods'
    },
    isFeedbackMenu(menuItem) {
      return menuItem && menuItem.url === 'user/Feedback'
    },
    getMenuBadgeCount(menuItem) {
      if (this.isSkillAuditMenu(menuItem)) {
        return this.pendingSkillCount
      }
      if (this.isFeedbackMenu(menuItem)) {
        return this.newFeedbackCount
      }
      return 0
    },
    handleMenuClick(menuItem) {
      unlockNotificationAudio()
      if (this.isFeedbackMenu(menuItem)) {
        this.newFeedbackCount = 0
      }
    },
    refreshAdminNotifications() {
      getAdminNotificationSummary({}).then(res => {
        if (!res || res.code !== 200) {
          return
        }
        const data = res.data || {}
        const nextSkillCount = Number(data.pendingSkillCount) || 0
        const nextSkillId = Number(data.latestPendingSkillId) || 0
        const nextSkillUpdateTime = Number(data.latestPendingSkillUpdateTime) || 0
        const nextFeedbackTotal = Number(data.feedbackCount) || 0
        const nextFeedbackId = Number(data.latestFeedbackId) || 0
        const wasReady = this.notificationSummaryReady
        const previousSkillCount = this.pendingSkillCount
        const previousFeedbackTotal = this.feedbackTotal
        const isNewAudit = wasReady && (
          nextSkillUpdateTime > this.latestPendingSkillUpdateTime ||
          (nextSkillUpdateTime === this.latestPendingSkillUpdateTime && nextSkillId > this.latestPendingSkillId)
        )
        const isInitialPending = !wasReady && nextSkillCount > 0
        const isNewFeedback = wasReady && nextFeedbackId > this.latestFeedbackId

        this.pendingSkillCount = nextSkillCount
        this.latestPendingSkillId = nextSkillId
        this.latestPendingSkillUpdateTime = nextSkillUpdateTime
        this.feedbackTotal = nextFeedbackTotal
        this.latestFeedbackId = nextFeedbackId
        this.notificationSummaryReady = true

        if (isNewAudit || isInitialPending) {
          const addedCount = isNewAudit ? Math.max(1, nextSkillCount - previousSkillCount) : nextSkillCount
          playNotificationSound()
          this.$notify({
            title: '技能审核提醒',
            message: isNewAudit
              ? `新增 ${addedCount} 条技能审核申请，当前共 ${nextSkillCount} 条待处理`
              : `当前有 ${nextSkillCount} 条技能审核申请待处理`,
            type: 'warning',
            duration: 8000,
            onClick: () => {
              this.$router.push({ path: '/goods/Goods' })
            }
          })
        }

        if (isNewFeedback) {
          const addedCount = Math.max(1, nextFeedbackTotal - previousFeedbackTotal)
          if (String(this.$route.path || '').toLowerCase() !== '/user/feedback') {
            this.newFeedbackCount += addedCount
          }
          playNotificationSound()
          this.$root.Bus.$emit('feedback:new')
          this.$notify({
            title: '用户投诉提醒',
            message: `新增 ${addedCount} 条用户投诉，请及时处理`,
            type: 'error',
            duration: 10000,
            onClick: () => {
              this.newFeedbackCount = 0
              this.$router.push({ path: '/user/Feedback' })
            }
          })
        }
      }).catch(() => {})
    }
  }
}
</script>
<style>
.tb-side-menu.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 256px;
  min-height: 400px;
}
.tb-side-menu.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.tb-side-menu .el-menu-item-group__title {
  padding: 0px;
}
.tb-side-menu .el-menu {
  border: none;
}
/* logo 区域 */
.logobox {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 16px;
  border-bottom: 1px solid rgba(79, 140, 255, 0.14);
  position: relative;
  overflow: hidden;
}
.logobox::before {
  content: '';
  position: absolute; inset: 0;
  background:
    linear-gradient(90deg, rgba(64, 158, 255, 0.12), transparent 70%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.92), transparent 50%);
  pointer-events: none;
}
.logo-glow {
  width: 42px; height: 42px;
  border-radius: 12px;
  display: flex; align-items: center; justify-content: center;
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.88), rgba(105, 177, 255, 0.72));
  box-shadow: 0 0 16px rgba(64, 158, 255, 0.18), inset 0 0 0 1px rgba(255, 255, 255, 0.32);
  position: relative;
  animation: tb-glow-pulse 2.6s ease-in-out infinite;
}
.logoimg {
  height: 28px;
  filter: drop-shadow(0 0 6px rgba(64, 158, 255, 0.28));
}
.logo-title { display: flex; flex-direction: column; line-height: 1.15; }
.logo-en {
  font-size: 14px; font-weight: 700; letter-spacing: 2px;
  background: linear-gradient(90deg, #22324a, #409eff);
  -webkit-background-clip: text; background-clip: text;
  color: transparent;
}
.logo-cn { font-size: 11px; color: #8da0bc; letter-spacing: 1px; }

/* 折叠时弹窗里的菜单 */
.el-menu--vertical .el-menu--popup .el-menu-item.is-active {
  color: #2563eb !important;
  background: rgba(64, 158, 255, 0.10) !important;
}

.tb-side-menu .el-submenu__title,
.tb-side-menu .el-menu-item {
  height: 46px !important;
  line-height: 46px !important;
  border-radius: 12px 0 0 12px;
  margin: 4px 10px 4px 12px;
  padding-left: 16px !important;
}

.tb-side-menu .el-submenu__title span,
.tb-side-menu .el-menu-item span {
  letter-spacing: 0.8px;
}

.tb-side-menu .el-submenu {
  margin-top: 6px;
}

.tb-side-menu .el-menu-item-group .el-menu-item {
  margin-left: 24px;
  margin-right: 10px;
  border-radius: 10px;
}

.menu-label {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.pending-skill-badge {
  line-height: 1;
}

.tb-side-menu.el-menu--collapse .el-submenu__title,
.tb-side-menu.el-menu--collapse .el-menu-item {
  margin-left: 8px;
  margin-right: 8px;
  padding-left: 20px !important;
}

/* 折叠状态下隐藏 logo 文字 */
.el-menu--collapse .logo-title { display: none; }
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue